var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgContentCutout = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M11.994 0C13.103 0 14 .898 14 2.006v9.988A2.005 2.005 0 0 1 11.994 14H2.006A2.005 2.005 0 0 1 0 11.994V2.006C0 .897.898 0 2.006 0ZM7.39 3.52c-2.01 0-3.56 1.39-3.56 3.45 0 2.05 1.55 3.45 3.56 3.45 1.46 0 2.31-.81 2.78-1.64l-1.22-.59-.137-.065-.004.029-.092.123c-.317.4-.76.703-1.32.703-1.105 0-1.901-.857-1.901-1.997s.796-2.02 1.9-2.02c.616 0 1.112.403 1.413.86l.008.016q.064-.045.133-.089l1.22-.6-.082-.14c-.484-.785-1.32-1.49-2.698-1.49"
})));
export default SvgContentCutout;